import { format } from "date-fns";

export type ArtValue = string | Date | [Date, Date];

const dateTokens: Record<string, string> = {
  "%Y": "yyyy", "%d": "dd", "%m": "MM", "%b": "MMM",
  "%I": "hh", "%H": "HH", "%M": "mm", "%p": "a", "%a": "EEE",
};

const directTokens = [...new Set(Object.values(dateTokens))].sort((a, b) => b.length - a.length);
const tokenPattern = new RegExp(`%%|%[YdmbaIHMp]|${directTokens.join("|")}`, "g");

export function supportedArtFormat(pattern: string) {
  // Unknown percent directives would render literally. Direct tokens and
  // separators (including words and Chinese text) use the renderer's rules.
  const remainder = pattern.replace(tokenPattern, "");
  const hasTokens = remainder !== pattern;
  return !remainder.includes("%") && (pattern === "" || hasTokens);
}

export function formatArtValue(value: ArtValue, pattern?: string): string {
  if (pattern === "") return "";
  if (pattern === undefined) {
    if (Array.isArray(value)) return value.map(date => format(date, "yyyy-MM-dd")).join(" - ");
    return value instanceof Date ? format(value, "yyyy-MM-dd") : value;
  }
  const dates = Array.isArray(value) ? value : [value instanceof Date ? value
    : new Date(2000, 0, 1, ...value.split(":").map(Number) as [number, number])];
  const seen = new Set<string>();
  let dateIndex = 0;
  return pattern.replace(tokenPattern, token => {
    if (token === "%%") return "%";
    const dateFnsToken = token.startsWith("%") ? dateTokens[token]! : token;
    // A repeated date token begins the end-date portion of the range format.
    if (dates.length === 2 && dateIndex === 0 && seen.has(dateFnsToken)) dateIndex = 1;
    seen.add(dateFnsToken);
    return format(dates[dateIndex]!, dateFnsToken);
  });
}
